import React/* , { useContext } */ from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Divider, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { MenuItems } from "./MenuData";
/* import { AuthContext } from "context/AuthContext"; */
import { useTranslation } from "react-i18next";
import { BranchOfficeSelect } from "components/BranchOfficesSelect/BranchOfficeSelect";

const useStyles = makeStyles((theme) => ({
  optionDrawer: {
    textDecoration: 'none',
    color: '#000000'
  },
  toolbar: theme.mixins.toolbar,
}))

const Menu = ({ action }) => {
  const { t } = useTranslation();
  /* const { logOut, globalUser } = useContext(AuthContext) */
  const menuItems = MenuItems(t)
  const classes = useStyles()
  const location = useLocation()
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const bo = JSON.parse(localStorage.getItem('mqBO'))
  console.log("bo", bo)
  return (<>
    {usr.company !== undefined ?
      <Box
        className={classes.toolbar}
        role="presentation"
      //onClick={() => action()}
      //onKeyDown={() => action()}
      >
        <div style={{ textAlign: "center", backgroundColor: "#ffffff", position: "sticky", top: 0, zIndex: 1 }}>
          {usr.role._id === "62be65fcd3c3b30408decc6f" ?
            <img src="/logo-inteliqr.jpg" style={{ width: "40%" }} alt="logo-img" />
            :
            <img src={usr.company.image !== undefined ? usr.company.image : "/no-image.png"} style={{ width: "40%", marginTop: 20, marginBottom: 20 }} alt="logo-img" />
          }
          <div style={{ color: "black", fontWeight: "bold", paddingLeft: 16, paddingRight: 16, paddingBottom: 16 }}>
            <div style={{ paddingBottom: 16 }}>{usr.company.name}</div>
            <BranchOfficeSelect width="100%" externalOnClick={() => action()} />
          </div>
        </div>
        <List>
          {menuItems.map((item, index) => {
            if (item.type === "menu" && item.role.includes(usr.role.identifier)) {
              return (
                <Link to={item.to} key={`${index}-${item.text}`} className={classes.optionDrawer}>
                  <ListItem button
                    onClick={() => action()}
                    sx={{
                      backgroundColor: (location.pathname === item.to) ? "#0268CA" : "#212145",
                      paddingTop: 0.5,
                      paddingBottom: 0.5,
                      '&:hover': {
                        backgroundColor: (location.pathname === item.to) ? "#0268CA" : "#212145",
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: (location.pathname === item.to) ? "#ffffff" : "#ffffff"
                      }}
                    >{item.icon}</ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{
                        color: (location.pathname === item.to) ? "#ffffff" : "#ffffff"
                      }}
                    />
                  </ListItem>
                </Link>
              )
            } else if (item.type === "divider") {
              return (
                <Divider key={index} color="#ffffff" sx={{ marginTop: 2, marginBottom: 2 }} />
              )
            } else { return null }
          })}
        </List>
        {usr.role._id !== "62be65fcd3c3b30408decc6f" &&
          <div style={{ textAlign: "center" }}>
            <img src="/logo-inteliqr.jpg" style={{ width: "40%" }} alt="logo-img" />
          </div>
        }
      </Box>
      : null}
  </>);
};
export default Menu;
